import { ServiceDefinition } from '@pershing/pershing-core';

export class NXIMISCServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;
    version = 'v1';
    family = 'netxinvestor';
    appName = 'miscellaneous-svc';
    serviceName = 'app';
    mnemonic = 'nxc';
    uri = '';

    static getInstance(): ServiceDefinition {
        if (!NXIMISCServiceDefinition.instance) {
            NXIMISCServiceDefinition.instance = new NXIMISCServiceDefinition();
        }
        return NXIMISCServiceDefinition.instance;
    }
}
